<template>
    <div>
        <div class="row page-titles">
            <div class="col-md-6 col-8 align-self-center">
                <h3 class="page-title">Inspection Reminders</h3>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body">
                        <div class="table-filters mb-16 md:mb-2">
                            <div class="row justify-content-between">
                                <div class="ml-2">
                                    <div class="form-inline flex items-center h-9 gap-x-2 gap-y-2 md:gap-y-0">
                                        <div class="input-group">
                                            <input type="text"
                                                   v-model="filterText"
                                                   @keyup.enter="doFilter"
                                                   placeholder="Search reminders"
                                                   class="form-control">
                                            <div class="input-group-append">
                                                <button class="btn btn-primary" type="button" @click="doFilter">
                                                    Search
                                                </button>
                                            </div>
                                        </div>

                                        <div class="btn-group">
                                            <button type="button" class="btn btn-outline-primary dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ reminderDateFilterLabel }}
                                            </button>

                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" @click.prevent="filterReminderDate('all')">All</a>
                                                <a class="dropdown-item" @click.prevent="filterReminderDate('current')">Current</a>
                                                <a class="dropdown-item" @click.prevent="filterReminderDate('upcoming')">Upcoming</a>
                                                <a class="dropdown-item" @click.prevent="filterReminderDate('none')">No Reminder Set</a>
                                            </div>
                                        </div>

                                        <div class="btn-group">
                                            <button type="button" class="btn btn-outline-primary dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ lastInspectionFilterLabel }}
                                            </button>

                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" @click.prevent="filterLastInspectionDate('all')">All</a>
                                                <a class="dropdown-item" @click.prevent="filterLastInspectionDate('mt_3_months_ago')">More Than 3 Months Ago</a>
                                                <a class="dropdown-item" @click.prevent="filterLastInspectionDate('mt_6_months_ago')">More Than 6 Months Ago</a>
                                                <a class="dropdown-item" @click.prevent="filterLastInspectionDate('mt_12_months_ago')">More Than 12 Months Ago</a>
                                                <a class="dropdown-item" @click.prevent="filterLastInspectionDate('never')">Never</a>
                                            </div>
                                        </div>

                                        <div class="btn-group">
                                            <button type="button" class="btn btn-outline-primary dropdown-toggle"
                                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                {{ nextInspectionFilterLabel }}
                                            </button>

                                            <div class="dropdown-menu">
                                                <a class="dropdown-item" @click.prevent="filterNextInspectionDate('all')">All</a>
                                                <a class="dropdown-item" @click.prevent="filterNextInspectionDate('lt_3_months')">In Less Than 3 Months</a>
                                                <a class="dropdown-item" @click.prevent="filterNextInspectionDate('lt_6_months')">In Less Than 6 Months</a>
                                                <a class="dropdown-item" @click.prevent="filterNextInspectionDate('lt_12_months')">In Less Than 12 Months</a>
                                                <a class="dropdown-item" @click.prevent="filterNextInspectionDate('never')">Never</a>
                                            </div>
                                        </div>

                                        <el-popover
                                            v-click-outside="hideAdvancedFilters"
                                            placement="bottom"
                                            title="Advanced Filters"
                                            :width="notSmallScreen ? '380' : '310'"
                                            v-model="advancedSearch"
                                            trigger="manual">

                                            <button slot="reference" class="btn btn-outline-primary hide-while-loading"
                                                    @click.prevent="toggleAdvancedSearch()">
                                                <i class="mdi mdi-filter-outline"></i>
                                            </button>

                                            <div>
                                                <div class="form-group">
                                                    <label>Reminder Date Range</label>
                                                    <el-date-picker
                                                        v-model="reminderDateRangeFilter"
                                                        value-format="yyyy-MM-dd"
                                                        type="daterange"
                                                        range-separator="-"
                                                        start-placeholder="From date"
                                                        end-placeholder="To date">
                                                    </el-date-picker>
                                                </div>

                                                <div class="form-group">
                                                    <label>Inspection Type</label>
                                                    <el-select v-model="inspectionTypeFilter" class="w-100" multiple>
                                                        <el-option
                                                            v-for="type in inspectionTypes"
                                                            :key="type"
                                                            :label="type | capitalize"
                                                            :value="type">
                                                        </el-option>
                                                    </el-select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Portfolio</label>
                                                    <el-select v-model="portfolioFilter" class="w-100">
                                                        <el-option
                                                            key="0PortfolioName"
                                                            label="All"
                                                            :value="null">
                                                        </el-option>
                                                        <el-option
                                                            v-for="portfolio in state.user.portfolios"
                                                            :key="portfolio.id + portfolio.name"
                                                            :label="portfolio.name | capitalize"
                                                            :value="portfolio.id">
                                                        </el-option>
                                                    </el-select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Complex</label>

                                                    <remote-select
                                                        v-model="assetGroupFilter"
                                                        @focus="searchAssetGroups"
                                                        :remote-method="searchAssetGroups"
                                                        :data="assetGroups"
                                                        :loading="loading"
                                                        item-label="name"
                                                        placeholder="Start typing to search complexes">
                                                        <template slot-scope="props">
                                                            <div class="content-group">
                                                                <h6>
                                                                    <span class="label label-light-primary mr-1" style="line-height: 14px !important;">
                                                                        {{ props.item.name }}
                                                                    </span>
                                                                </h6>
                                                            </div>
                                                        </template>
                                                    </remote-select>
                                                </div>

                                                <div class="form-group">
                                                    <button class="btn btn-primary" @click="doFilter">Apply</button>
                                                </div>
                                            </div>
                                        </el-popover>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="hasAdvancedFilters" class="pt-12 md:py-2 ml-2">
                            <div>
                                <span class="mr-1 font-bold text-base">Advanced filters: </span>

                                <span v-if="hasReminderDateRangeFilter"
                                      class="label label-light-inverse mr-1">
                                    {{ searchParams.todo_date_range_filter[0] }} - {{ searchParams.todo_date_range_filter[1] }}
                                </span>

                                <template v-if="hasInspectionTypeFilter">
                                    <span class="label label-light-inverse mr-1" v-for="type in searchParams.inspection_type_filter">
                                        {{ type }}
                                    </span>
                                </template>

                                <template v-if="hasAssetGroupFilter">
                                    <span class="label label-light-inverse mr-1">
                                        {{ assetGroups.find(ag => ag.id === searchParams.asset_group_filter).name }}
                                    </span>
                                </template>

                                <template v-if="hasPortfolioFilter">
                                    <span class="label label-light-inverse mr-1">
                                        {{ state.user.portfolios.find(p => p.id === searchParams.portfolio).name }}
                                    </span>
                                </template>
                                <button @click="clearAdvancedFilters()" class="px-0.5 py-0 hover:bg-gray-100 btn text-sm text-blue-500 font-thin outline-none">
                                    Clear Advanced Filters
                                </button>
                            </div>
                        </div>

                        <div class="table-responsive">
                            <vuetable ref="vuetable"
                                      api-url="/reminders"
                                      :fields="columns"
                                      :css="css.table"
                                      pagination-path=""
                                      :append-params="searchParams"
                                      no-data-template="No Inspection Reminders With Those Filters"
                                      @vuetable:pagination-data="onPaginationData">

                                <template slot="name" slot-scope="props">
                                    <a :href="'/assets/' + props.rowData.id" target="_blank">
                                        {{ props.rowData.name }}
                                    </a>
                                </template>

                                <template slot="tenant" slot-scope="props">
                                    <div class="flex flex-col">
                                        <span class="font-medium"> {{ props.rowData.tenant.full_name }}</span>
                                        <span> {{ props.rowData.tenant.mobile }}</span>
                                        <span> {{ props.rowData.tenant.email }}</span>
                                    </div>
                                </template>

                                <template slot="next_scheduled_inspection" slot-scope="props">
                                    <div class="text-nowrap">
                                        <a v-if="props.rowData.next_inspection" :href="'/inspections/' + props.rowData.next_inspection.id"
                                           :class="props.rowData.next_inspection.status === 'scheduled' && new Date(props.rowData.next_inspection.date) < new Date() ?
                                           'text-red-500 hover:text-red-700' : 'text-blue-500 hover:text-blue-700'">
                                            {{ props.rowData.next_inspection.type }} &triangleright; {{ props.rowData.next_inspection.date | localeUnawareDatetime }}
                                        </a>
                                    </div>
                                </template>
                            </vuetable>

                            <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>

                            <div class="text-right">
                                <vuetable-pagination ref="pagination"
                                                     @vuetable-pagination:change-page="onChangePage"
                                ></vuetable-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AssetGroupSearch from "../../mixins/asset-group-search";
import vueTableMixin from "../../mixins/vuetable-css-mixin";

export default {
    name: "RemindersList",

    mixins: [vueTableMixin, AssetGroupSearch],

    props: {
        inspectionTypes: {
            required: true,
            type: Array,
        }
    },

    data () {
        return {
            filterText: "",
            reminderDateFilter: "all",
            lastInspectionDateFilter: "all",
            nextInspectionDateFilter: "all",
            portfolioFilter: null,
            advancedSearch: false,
            assetGroupFilter: null,
            inspectionTypeFilter: null,
            reminderDateRangeFilter: null,
            searchParams: {},
            columns: [
                {
                    name: "__slot:name",
                    title: "Asset",
                    sortField: "assets.name",
                    dataClass: "text-nowrap column-width-200"
                },
                {
                    name: "portfolio.name",
                    title: "Portfolio",
                    dataClass: "text-nowrap"
                },
                {
                    name: "__slot:tenant",
                    title: "Tenant Details",
                    dataClass: "text-nowrap column-width-200"
                },
                {
                    name: "last_inspection",
                    title: "Last Inspection Done",
                    callback: "lastInspection",
                    dataClass: "text-nowrap"
                },
                {
                    name: "__slot:next_scheduled_inspection",
                    title: "Next Scheduled Inspection",
                },
                {
                    name: "inspection_reminder.reminder_date",
                    title: "Reminder Date",
                    callback: "formatDate",
                    dataClass: "text-nowrap",
                    sortField: "reminders.reminder_date",
                },
                {
                    name: "inspection_reminder",
                    title: "Description",
                    callback: "description",
                    dataClass: "column-multiline text-nowrap column-width-200"
                },
            ]
        };
    },

    created () {
        let url = new URL(window.location.href);
        let preselectedReminderDateFilter = url.searchParams.get("reminder_date_filter");

        if (preselectedReminderDateFilter) {
            this.reminderDateFilter = preselectedReminderDateFilter;
            this.setSearchParams();
        }
    },

    computed: {
        lastInspectionFilterLabel () {
            switch (this.lastInspectionDateFilter) {
                case "all":
                    return "Last Inspection";

                case "mt_3_months_ago":
                    return "More than 3 months ago";

                case "mt_6_months_ago":
                    return "More than 6 months ago";

                case "mt_12_months_ago":
                    return "More than 12 months ago";

                case "never":
                    return "Never";
            }

            return "Last Inspection";
        },

        nextInspectionFilterLabel () {
            switch (this.nextInspectionDateFilter) {
                case "all":
                    return "Next Inspection";

                case "lt_3_months":
                    return "In Less than 3 months";

                case "lt_6_months":
                    return "In Less than 6 months";

                case "lt_12_months":
                    return "In Less than 12 months";

                case "never":
                    return "Never";
            }

            return "Next Inspection";
        },

        reminderDateFilterLabel () {
            // current, upcoming, all, none
            if (this.reminderDateFilter === "none") {
                return "No Reminder Set";
            }
            return _.capitalize(this.reminderDateFilter) + " Reminders";
        },

        hasAdvancedFilters () {
            return this.hasReminderDateRangeFilter || this.hasInspectionTypeFilter || this.hasAssetGroupFilter || this.hasPortfolioFilter;
        },

        hasReminderDateRangeFilter () {
            return (this.searchParams.todo_date_range_filter && this.searchParams.todo_date_range_filter.length > 0);
        },

        hasInspectionTypeFilter () {
            return this.searchParams.inspection_type_filter && this.searchParams.inspection_type_filter.length > 0;
        },

        hasAssetGroupFilter () {
            return this.searchParams.asset_group_filter && this.searchParams.asset_group_filter > 0;
        },

        hasPortfolioFilter () {
            return this.searchParams.portfolio && this.searchParams.portfolio > 0;
        },
    },

    methods: {
        description (reminder) {
            if (_.isEmpty(reminder)) {
                return "";
            }

            let val;
            if (reminder.description) {
                val = "<div><p style='font-weight: 500'>" + reminder.description + "</p>";
            }

            if (!reminder.notes) {
                val += "<p>" + reminder.notes + "</p></div>";
            }

            return val;
        },

        // Callback for field last inspection instead of slot
        lastInspection (inspection) {
            if (!inspection) {
                return "Never";
            }

            return "<a style='color: #6faaf3;' href=\'/inspections/" + inspection.id + "\'>" + inspection.type + " &triangleright; " + this.$options.filters.localeUnawareDatetime(inspection.date) + "</a>";
        },

        formatDate (date) {
            return date ? this.$options.filters.date(date) : "No Reminder Set";
        },

        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onChangePage (page) {
            this.$refs.vuetable.changePage(page);
        },

        clearAdvancedFilters () {
            this.assetGroupFilter = null;
            this.inspectionTypeFilter = null;
            this.reminderDateRangeFilter = null;
            this.portfolioFilter = null;
            this.doFilter();
        },

        setSearchParams () {
            this.searchParams = {
                "filter_text": this.filterText,
                "last_inspection_date_filter": this.lastInspectionDateFilter,
                "next_inspection_date_filter": this.nextInspectionDateFilter,
                "reminder_date_filter": this.reminderDateFilter,
                "portfolio_id": this.portfolioFilter,
                "asset_group_filter": this.assetGroupFilter ? this.assetGroupFilter.id : null,
                "inspection_type_filter": this.inspectionTypeFilter,
                "todo_date_range_filter": this.reminderDateRangeFilter,
            };
        },

        doFilter () {
            this.setSearchParams();
            Vue.nextTick(() => this.$refs.vuetable.reload());
        },

        filterReminderDate (filter) {
            this.reminderDateFilter = filter;
            this.doFilter();
        },

        filterLastInspectionDate (filter) {
            this.lastInspectionDateFilter = filter;
            this.doFilter();
        },

        filterNextInspectionDate (filter) {
            this.nextInspectionDateFilter = filter;
            this.doFilter();
        },

        toggleAdvancedSearch () {
            this.advancedSearch = !this.advancedSearch;
        },

        hideAdvancedFilters () {
            this.advancedSearch = false;
        },
    },
};
</script>
